{
	"textures": [
		{
			"image": "tree_small.png",
			"format": "RGBA8888",
			"size": {
				"w": 216,
				"h": 544
			},
			"scale": 1,
			"frames": [
				{
					"filename": "tree/tree08",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 20,
						"y": 10,
						"w": 107,
						"h": 150
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 107,
						"h": 150
					}
				},
				{
					"filename": "tree/tree02",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 27,
						"y": 26,
						"w": 99,
						"h": 134
					},
					"frame": {
						"x": 110,
						"y": 1,
						"w": 99,
						"h": 134
					}
				},
				{
					"filename": "tree/tree03",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 27,
						"y": 26,
						"w": 99,
						"h": 134
					},
					"frame": {
						"x": 110,
						"y": 137,
						"w": 99,
						"h": 134
					}
				},
				{
					"filename": "tree/tree04",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 20,
						"y": 26,
						"w": 106,
						"h": 134
					},
					"frame": {
						"x": 1,
						"y": 153,
						"w": 106,
						"h": 134
					}
				},
				{
					"filename": "tree/tree05",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 20,
						"y": 26,
						"w": 106,
						"h": 134
					},
					"frame": {
						"x": 109,
						"y": 273,
						"w": 106,
						"h": 134
					}
				},
				{
					"filename": "tree/tree06",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 20,
						"y": 26,
						"w": 106,
						"h": 134
					},
					"frame": {
						"x": 1,
						"y": 289,
						"w": 106,
						"h": 134
					}
				},
				{
					"filename": "tree/tree07",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 20,
						"y": 26,
						"w": 106,
						"h": 134
					},
					"frame": {
						"x": 109,
						"y": 409,
						"w": 106,
						"h": 134
					}
				},
				{
					"filename": "tree/tree01",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 38,
						"y": 51,
						"w": 64,
						"h": 109
					},
					"frame": {
						"x": 1,
						"y": 425,
						"w": 64,
						"h": 109
					}
				},
				{
					"filename": "tree/tree00",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 140,
						"h": 163
					},
					"spriteSourceSize": {
						"x": 53,
						"y": 91,
						"w": 25,
						"h": 63
					},
					"frame": {
						"x": 67,
						"y": 425,
						"w": 25,
						"h": 63
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:bd1aa356c6cab68ee67cae155d07af5c:2f3e28319562f1105a4bd7b7a92e9d6b:2173a1335a5d5ebcd1a70c1067f33669$"
	}
}
